export const FOCUSABLES_SELECTOR =
  'iframe, a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';
